export default "__VITE_ASSET__C7l0xj7P__"